import { calculateAge, formatDate, parseIsoDateTime } from '@ninja/utilities';
import { Relationship } from '../../../common';
import { useAppPlatformContextOptions } from '../../../contexts/app';
import { MemberData } from './useMembersData';

const useMemberDocumentData = () => {
	const { translate: t } = useAppPlatformContextOptions();

	const onTransformData = (data: Partial<MemberData>[]) => {
		return data.map((el) => ({
			memberInfo: {
				firstName: el.firstName,
				lastName: el.lastName,
				unifiedNumber: el.unifiedNumber,
				isPrincipal: el.isPrincipal,
				age: el.dateOfBirth ? calculateAge(parseIsoDateTime(el.dateOfBirth)!) : undefined,
				gender: el.gender,
				emiratesId: el.emiratesIdNumber,
				passportNumber: el.passportNo,
				visaFileNumber: el.visaFileNumber,
				nationality: el.nationality,
				dateOfBirth: formatDate(parseIsoDateTime(el.dateOfBirth)),
				maritalStatus: el.maritalStatus,
				relationship: el.relationshipTypeId === Relationship.Self ? t('documents-review:sponsor') : el.relationship,
				emirate: el.emirate,
				memberId: el.memberId,
				occupation: el.occupation,
			},
			fileUrl: el.fileUrl ?? '',
		}));
	};

	return { onTransformData };
};

export default useMemberDocumentData;
